/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const l = (e) => e != null, a = (e, t) => {
  for (let r = 0; r < e.length; r++)
    if (e.charAt(r) !== t)
      return !1;
  return !0;
}, d = (e, t, r) => {
  let n = e;
  return r && (n = [r].concat(n)), n.slice(t).concat(n.slice(0, t));
}, x = (e, t, r) => {
  if (!l(e))
    return !1;
  let n = String(e);
  return r && (n = n.toLowerCase()), n.indexOf(t) === 0;
}, C = (e, t, r, n, s) => {
  const o = e.offsetHeight, g = t.children.item(r), f = g.offsetTop + (s ? n - e.scrollTop : 0), c = g.offsetHeight;
  if (s) {
    let u = 0;
    f + c > o ? u = f + c - o : f < 0 && (u = f), u !== 0 ? e.scrollTop += u : e.scrollTop === 0 && n !== 0 && (e.scrollTop = n);
  } else
    f + c > o + e.scrollTop ? e.scrollTop = f + c - o : f < e.scrollTop && (e.scrollTop -= e.scrollTop - f);
}, h = (e, t, r) => {
  let n = -1;
  if (t) {
    t = t.toLowerCase();
    for (let s = 0; s < e.length; s++) {
      const o = (i(e[s], r) || "") + "";
      if (o && o.toLowerCase().startsWith(t)) {
        n = s;
        break;
      }
    }
  }
  return n;
}, T = (e, t, r, n = !1) => {
  const s = (o) => n ? o : o.toLowerCase();
  return e.findIndex((o) => r ? s(i(o, r)) === s(t) : s(t) === s(o.toString()));
}, i = (e, t) => {
  if (t && l(e)) {
    const r = t.split(".");
    let n = e;
    return r.forEach((s) => {
      n = n ? n[s] : void 0;
    }), n;
  }
  return e;
}, w = (e, t, r) => {
  if (!e)
    return;
  const n = e.findIndex((s) => i(s, t) === r);
  return e[n];
}, I = (e = [], t = [], r) => {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!p(e[n], t[n], r))
      return !1;
  return !0;
}, D = (e, t, r) => {
  t.forEach((n) => {
    const s = e.findIndex((o) => p(o, n, r));
    s !== -1 && e.splice(s, 1);
  });
}, p = (e, t, r) => e === t || l(e) === l(t) && i(e, r) === i(t, r), L = (e, t, r) => {
  if (t) {
    const n = T(e, t, r, !0);
    return n !== -1 ? e[n] : e[h(e, t, r)];
  }
  return e[0];
}, H = (e, t = [], r) => {
  let n = "";
  if (e) {
    const s = t[h(t, e, r)];
    if (s) {
      const o = i(s, r);
      e.toLowerCase() !== o.toLowerCase() && (n = o.substring(e.length));
    }
  }
  return n;
}, S = (e) => {
  e.target.nodeName !== "INPUT" && e.preventDefault();
}, y = (e, t, r) => !!e != !!t || e.text !== t.text ? !1 : e === t || I(e.data, t.data, r), N = (e) => {
  const t = e.filter((r, n) => e.some((s, o) => s === r && o !== n));
  return Array.from(new Set(t));
};
export {
  p as areSame,
  w as findByFieldValue,
  L as getFocusedItem,
  T as getItemIndexByText,
  i as getItemValue,
  N as getPlainDataDuplicates,
  l as isPresent,
  h as itemIndexStartsWith,
  I as matchDataCollections,
  y as matchTags,
  x as matchText,
  S as preventDefaultNonInputs,
  D as removeDataItems,
  a as sameCharsOnly,
  C as scrollToItem,
  d as shuffleData,
  H as suggestValue
};
